import { hexColor } from '@/game/utils'
export default {
  name: 'AppTeam',
  props: {
    state: { type: Object, required: true }
  },
  data () {
    return {
      teams: this.state.teams
    }
  },
  watch: {
    state: {
      handler (v) {
        this.teams = v.teams
      },
      deep: true
    }
  },
  methods: {
    hexColor: hexColor
  }
}
